
import Vue from "vue";
import LangSwitcher from "@/components/settings/LangSwitcher.vue";
import { timeToStart, timeToEnd } from "@/config/registrationWindow";
/**/

export default Vue.extend({
  name: "Login",

  /**/
  components: { LangSwitcher },
  /**/

  data: () => ({
    model: {
      email: "" as string,
      password: "" as string,
    },
    errorMessage: "" as string,
    errorMessages: {} as any,
    showPassword: false as boolean,
    forgot: false as boolean,
    usmfLogo: require("@/assets/images/usmf-logo.png"),
    currentDate: new Date(),
    timeToStart,
    timeToEnd,
  }),

  computed: {
    blocked() {
      return (
        this.currentDate < new Date(this.timeToStart) ||
        this.currentDate > new Date(this.timeToEnd)
      );
    },
    PasswordType(): string {
      if (this.showPassword) {
        return "text";
      }
      return "password";
    },
    rules() {
      return {
        email: [
          (v: string): boolean | string =>
            !!v || (this.$t("auth.validation.required") as string),
        ],
        password: [
          (v: string): boolean | string =>
            !!v.length || (this.$t("auth.validation.required") as string),
        ],
      };
    },
    isManager(): boolean {
      const [, , manager] = document.location.href;
      return manager === "manager";
    },
    periodText(): string {
      const months = [
        "ianuarie", "februarie", "martie", "aprilie", "mai", "iunie",
        "iulie", "august", "septembrie", "octombrie", "noiembrie", "decembrie",
      ];
      const format = (value: string): string => {
        const d = new Date(value);
        const day = d.getDate();
        const month = months[d.getMonth()];
        const year = d.getFullYear();
        const hours = String(d.getHours()).padStart(2, "0");
        const minutes = String(d.getMinutes()).padStart(2, "0");
        return `${day} ${month} ${year} ${hours}:${minutes}`;
      };
      return `${format(this.timeToStart)} - ${format(this.timeToEnd)}`;
    },
  },

  methods: {
    isTimeToEnd() {
      return new Date() < new Date(this.timeToEnd);
    },
    async signIn(): Promise<void> {
      try {
        if (await (this.$refs.form as any).validate()) {
          const response = await this.$API.auth().login(this.model);

          if (response.hasOwnProperty("token")) {
            await this.$store.dispatch("authentication/login", response);
            document.location.href = origin;
          }
          localStorage.removeItem("form");
        }
      } catch (e) {
        if (e.message == "Unauthenticated.") {
          this.errorMessage = "Neautentificat.";
        } else {
          this.errorMessage = e.message;
        }
      }
    },
    async forgotPassword(): Promise<void> {
      try {
        const response: any = await this.$API
          .auth()
          .forgot({ email: this.model.email });

        await this.$store.dispatch("alert/showSuccess", response.message);
        this.forgot = false;
      } catch (e) {
        this.errorMessage = e.message;
      }
    },
    togglePasswordType(): void {
      this.showPassword = !this.showPassword;
      this.errorMessage = "";
    },
    toggleForgot(): void {
      this.forgot = !this.forgot;
      this.errorMessage = "";
    },
    submitForm(): void {
      if (this.forgot) {
        try {
          this.forgotPassword();
        } catch (e) {
          console.log(e);
        }
      } else {
        this.signIn();
      }
    },
  },
});
